import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WebsiteConfigService } from '../../shared/services/website-config.service';
import { CmsService } from '../../cms/services/cms.service';
import {LoadingService} from '../../shared/services/loading.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
  hasAppointments$: Observable<boolean>;

  private unsubscribe$ = new Subject;

  public isLoading = false;
  public isHomepageLoaded = false;
  public cmsHome: any;

  constructor(
    private _websiteConfigService: WebsiteConfigService,
    private _cmsService: CmsService,
    private _loadingService: LoadingService
  ) { }


  ngOnInit(): void {
    this.hasAppointments$ = this._websiteConfigService.hasAppointments();

    this._loadingService.getSkeletonLoadingStatus().pipe(takeUntil(this.unsubscribe$)).subscribe((status) => {
      this.isLoading = status;
    });

    this._cmsService.hasCmsEnabled$.pipe(takeUntil(this.unsubscribe$)).subscribe(isEnabled => {
      if (isEnabled) {
        const loadingItemId = 'homepage-init-content';
        this._cmsService.getHomePage(loadingItemId).pipe(takeUntil(this.unsubscribe$)).subscribe(home => {
          if (home && home != undefined) {
            this.cmsHome = home;
            this.isHomepageLoaded = true;
          }
        })
      } else if (isEnabled != undefined) {
        this.isHomepageLoaded = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
